export default __webpack_public_path__ + "static/media/step3.afef9569.svg";